import { useMemo } from 'react';
import useTheme from 'branding/theme';
import useSectionMargin from '../../../hooks/useSectionMargin';
const useNavGroupStyles = ({ isFocused, margin, marginHorizontal, marginVertical, marginTop, marginBottom, marginRight, marginLeft, styles }) => {
    const { borders, colors } = useTheme();
    const marginStyles = useSectionMargin({
        margin,
        marginHorizontal,
        marginVertical,
        marginTop,
        marginBottom,
        marginRight,
        marginLeft
    });
    const wrapperStyles = useMemo(() => ({
        listStyleType: 'none',
        margin: 0,
        padding: 0,
        ...borders.base,
        ...borders.shape.rounded,
        ...(isFocused ? { color: colors.neutrals.textAlpha } : borders.variant.secondary),
        ...marginStyles,
        ...styles
    }), [borders, styles, marginStyles, isFocused, colors]);
    const itemStyles = useMemo(() => ({
        display: 'block',
        ...borders.bottom,
        ...(isFocused ? { color: colors.neutrals.textAlpha } : borders.variant.secondary)
    }), [borders, isFocused, colors]);
    return { wrapperStyles, itemStyles };
};
export default useNavGroupStyles;
//# sourceMappingURL=useNavGroupStyles.js.map